import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ConfigManagerService } from '../services/config-manager.service';
import { SharedStateService } from '../services/shared-state.service';
import { DateOnly } from '../models/date-only';

const transformDateOnlyDates = (obj: any): any => {
  if (obj instanceof DateOnly) {
    return obj.toJSON()
  }

  if (obj instanceof Date) {
    return obj;
  }

  if (typeof obj != 'object' || obj === null) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(item => transformDateOnlyDates(item));
  }

  const newObj: any = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      newObj[key] = transformDateOnlyDates(obj[key]);
    }
  }
  return newObj;
}

export const HTTP_INTERCEPTOR: HttpInterceptorFn = (req, next) => {
  const CONFIGURATION_MANAGER = inject(ConfigManagerService);
  const SHARED_STATE_SERVICE = inject(SharedStateService);
  const API_URL = CONFIGURATION_MANAGER.apiUrl;
  const URL = req.url;
  if (URL.includes('/assets/') || URL.startsWith('assets/')) {
    return next(req);
  }
  if (URL.endsWith('/token')) {
    return next(req);
  } else {
    const newBody = transformDateOnlyDates(req.body);
    const FULL_URL = `${API_URL}/${URL}`;
    const NEW_HEADERS = req.headers
      .set('Authorization', `Bearer ${SHARED_STATE_SERVICE.authtoken()}`).set('Access-Control-Allow-Origin', 'true').set('Content-Type', 'application/json')
    const NEW_REQUEST = req.clone({
      headers: NEW_HEADERS,
      url: FULL_URL,
      body: newBody
    });

    return next(NEW_REQUEST);
  }
};
